import type { AxiosInstance } from 'axios';
import { ProviderRepository } from './ProviderRepository';
import { SiteRepository } from './SiteRepository';
import { UserRepository } from '../../Utils/UserRepository';

class ApiService {
  private apiClient: AxiosInstance;

  // Public Repositories
  public providers: ProviderRepository;
  public sites: SiteRepository;
  public user: UserRepository;

  constructor(client: AxiosInstance) {
    this.apiClient = client;

    // Initialize Repositories
    this.providers = new ProviderRepository(this.apiClient);
    this.sites = new SiteRepository(this.apiClient);
    this.user = new UserRepository(this.apiClient);
  }

  get client() {
    return this.apiClient;
  }
  
  // Compatibility Accessor for dynamic access (e.g. api[entityType])
  public getRepository(entityType: string) {
    const key = entityType.toLowerCase();
    if (key === 'providers') return this.providers;
    if (key === 'sites') return this.sites;
    if (key === 'users') return this.user;
    return null;
  }
}

export default ApiService;
